import BulkOrderGiftCardsIndexPage from '../../../components/pages/bulk_order/gift_cards/BulkOrderGiftCardsIndexPage.vue'
export default {
  components: { BulkOrderGiftCardsIndexPage }
}
